import { TransportZoneService } from 'src/app/angularJS/services/transport-zone/transport-zone.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { ToolbarController } from 'src/app/angularJS/layout/toolbar/toolbar.controller';

export class TransportZonesController {
  public static $inject = [
    'transportZoneService',
    'transportZonesResponse',
    '$state',
    'UserMessages',
    '$rootScope',
    'ACTToolbarService',
    'breadcrumbService',
    'userService',
    'LinkBuilder',
    'QueryBuilder'

  ];
  public uploadDetail: any = {};
  public transportZones: Array<InterACT.Interfaces.TransportZones.TransportZone> = [];
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    perPageCount: 15,
    currentPage: 1,
    totalCount: 0
  };
  public searchText: string = undefined;

  constructor(
    private transportZoneService: TransportZoneService,
    transportZonesResponse: InterACT.Interfaces.TransportZones.TransportZonesResponse,
    private $state: ng.ui.IStateService,
    private UserMessages,
    private $rootScope: InterACT.Interfaces.IActoraRootScope,
    private toolbarService: ACTToolbarService,
    private breadcrumbService: BreadcrumbService,
    private userService: UserService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder
  ) {
    this.activate();
    this.transportZones = transportZonesResponse.transportZones.map((zoneWithMeta) => {
      return zoneWithMeta.transportZone;
    });
    this.paginatorData.totalCount = transportZonesResponse.meta.totalCount;
  }

  /**
   * A method that gets a page worth of transport zones
   * @param pageNumber the number of the page to retrieve
   * @param perPageCount the amount of transport zones per page to retrieve
   */
  public getTransportZones(pageNumber: number, perPageCount: number) {
    this.$rootScope.showSpinner = true;
    const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);

    const builder = this.searchText === undefined ? this.queryBuilder
      .newParam()
      .fieldIs('scheme.link', schemeLink)
      .or()
      .fieldIs('scheme.link', '/globalScheme')
      .sortBy([{ columnName: 'name', direction: 'asc' }])
    : this.queryBuilder
      .newParam()
      .openSubQuery()
      .fieldIs('scheme.link', schemeLink)
      .or()
      .fieldIs('scheme.link', '/globalScheme')
      .closeSubQuery()
      .and()
      .fieldContains('name', this.searchText)
      .sortBy([{ columnName: 'name', direction: 'asc' }]);

    this.transportZoneService.getList(pageNumber, perPageCount, builder.getParam()).then((response) => {
      this.paginatorData.totalCount = response.meta.totalCount;
      this.transportZones = response.transportZones.map((zoneWithMeta) => {
        return zoneWithMeta.transportZone;
      });
      this.$rootScope.showSpinner = false;
    });
  }

  /**
   * A method that gets invoked when a file has been imported into the browser
   */
  public onFileImported = () => {
    const r = new FileReader();
    r.onload = (e: any) => {
      const contents = e.target.result;
      const importedTransportZone = this.createImportedTransportZoneFromCsvFile(contents);

      if (importedTransportZone) {
        this.$state.go('transport-zone-edit', { importedTransportZone: importedTransportZone });
      }
    };

    r.readAsText(this.uploadDetail.file);
  };

  /**
   * A method that takes the supplied transport zone and moves it to a screen where it can be edited
   * @param transportZone the transport zone to be edited
   */
  public editTransportZone = (transportZone: InterACT.Interfaces.TransportZones.TransportZone) => {
    this.$state.go(`transport-zone-edit`, { zoneId: transportZone.id });
  };

  /**
 * A method that deletes the supplied transport zone
 * @param transportZone the transport zone to be deleted
 */
  public deleteTransportZone = (transportZone: InterACT.Interfaces.TransportZones.TransportZone) => {
    this.$rootScope.showSpinner = true;
    this.UserMessages.buildConfirmDialog(
      'DELETE_TRANSPORT_ZONE',
      'CONFIRM_DIALOG.TRANSPORT_ZONES.DELETE_CONFIRM',
      undefined,
      'CONFIRM_DIALOG.TRANSPORT_ZONES.CONFIRM',
      'CONFIRM_DIALOG.TRANSPORT_ZONES.CANCEL'
    ).then(() => {
      this.transportZoneService.delete(transportZone.id).then(() => {
        this.UserMessages.showToast('TOAST_MESSAGE.TRANSPORT_ZONES.DELETED');
        this.$rootScope.showSpinner = false;
        this.getTransportZones(1, 15);
      });
    });
  };

  /**
   * Searches and displays the existing transport zones on the scheme for matches on their zone name
   * @param searchQuery the search query written by the user 
   */

   public search = (searchQuery: string) => {
    if ( searchQuery === '') {
      this.searchText = undefined
      this.getTransportZones(1, this.paginatorData.perPageCount);
      return;
    }

    var schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);

    var transportZoneQuery = this.queryBuilder
      .newParam()
      .fieldIs('scheme.link', schemeLink)
      .and()
      .fieldContains('name', searchQuery)
      .getParam();

    this.$rootScope.showSpinner = true;
    this.paginatorData.currentPage = 1;
    this.transportZoneService.getList(this.paginatorData.currentPage, this.paginatorData.perPageCount, transportZoneQuery).then((response) => {
      let zones: Array<InterACT.Interfaces.TransportZones.TransportZone> = [];
      response.transportZones.forEach(zoneWithMeta => zones.push(zoneWithMeta.transportZone));
      this.transportZones = zones.length > 0 ? zones : [];
      this.paginatorData.totalCount = response.meta.totalCount;
      this.$rootScope.showSpinner = false;
    });

    this.searchText = searchQuery;
  }

  /**
 * Creates a transport zone object from from a csv string
 * @param csvFileContents the contents of a csv file that contains a transport zone
 */
  private createImportedTransportZoneFromCsvFile(csvFileContents: string) {
    const transportZone: InterACT.Interfaces.IImportedTransportZone = {
      locations: []
    };
    const transportZoneDataStrings = csvFileContents.split('\n');

    if (transportZoneDataStrings.length < 2) {
      return undefined;
    }

    const transportZonePropertyNames = transportZoneDataStrings[0].split(',');
    const transportZonePropertyValues = transportZoneDataStrings[1].split(',');

    if (transportZonePropertyNames.length !== transportZonePropertyValues.length) {
      return;
    }

    for (let c = 0; c < transportZonePropertyNames.length; c++) {
      const propertyName = transportZonePropertyNames[c].replace('\r', '');
      const propertyValue = transportZonePropertyValues[c].replace('\r', '');

      transportZone[propertyName] = propertyValue;
    }

    if (transportZoneDataStrings.length < 4) {
      return transportZone;
    }

    for (let c = 3; c < transportZoneDataStrings.length; c++) {
      const locationTypeDataString = transportZoneDataStrings[c].split(',');

      if (locationTypeDataString.length < 2) {
        continue;
      }

      const locationRefPropertyName = locationTypeDataString[0].replace('\r', '');
      const locationRef = locationTypeDataString[1].replace('\r', '');

      transportZone.locations.push({ referenceType: locationRefPropertyName, reference: locationRef });
    }

    return transportZone;
  }

  /**
   * A method that is called during controller isntantiation
   */
  private activate() {
    this.toolbarService.getToolbar('primary').then((toolbar: ToolbarController) => {
      toolbar.setTitle('ZONE_UPLOADS');
    });

    this.breadcrumbService.setBreadcrumbs([{
      name: 'TRANSPORT_LOCATIONS',
      sref: 'x'
    },
    {
      name: 'ZONE_UPLOADS',
      sref: 'transport-zones'
    }]);
  }
}